import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { SurveyStatusV2Service } from "../../../survey-status-v2.service";
import { NuevoColaboradorComponent } from "../nuevo-colaborador/nuevo-colaborador.component";
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';

const moment = require('moment');

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  datosColaborador: any;
  modificacion: boolean;
  statusSalidaModal: number;

  acciones = [
    { id: 'modificar', nombre: 'Modificar los datos del colaborador seleccionado', icono: 'edit', bloqueado: true, funcion: 'editaColaborador' },
    { id: 'borrar', nombre: 'Borrar el colaborador seleccionado', icono: 'delete_forever', bloqueado: true, funcion: 'borrarColaborador' },
    { id: 'invitacion', nombre: 'Reenviar invitación', icono: 'email', bloqueado: true, funcion: 'enviaInvitacion' },
    { id: 'recordatorio', nombre: 'Reenviar recordatorio', icono: 'notifications', bloqueado: true, funcion: 'enviaRecordatorio' },
    { id: 'respuestas', nombre: 'Eliminar respuesta de encuesta', icono: 'delete_sweep', bloqueado: true, funcion: 'borraRespuestas' },
    { id: 'resetSur', nombre: 'Resetear variable survey', icono: 'lock_reset', bloqueado: true, funcion: 'resetSurve' },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<ModalComponent>,
    private dialog: MatDialog,
    private translateSrv: TranslateService,
    private surveyServ: SurveyStatusV2Service
  ) { }

  ngOnInit() {
    console.log("datosRecibidos:",this.datos);
    if (this.datos.datosColab.id_status==5) {
      this.activarBoton('resetSur',false);
    }

    let refColab = this.datos.datosColab;
    let refProd = this.datos.datosEmpresaProducto;
    this.getDatosColaborador();
    if(refProd.statusEncuesta != 2){
      if(moment().isAfter(moment(refProd.fechaLanzamiento)) && refColab.email != '*' && refColab.id_status != 4 && refProd.tipoProducto != 52){
        this.activarBoton('invitacion',false);
        this.activarBoton('recordatorio',false);
      }
    }

    this.activarBoton('respuestas',false);
  }

  prro(){
    console.log("hola prro");
  }

  activarBoton(id:string, status:boolean){
    let boton = this.acciones.find(item => item.id == id);
    if(boton != undefined){
      boton.bloqueado = status;
    }
  }

  getDatosColaborador(){
    let refProd = this.datos.datosEmpresaProducto;
    this.surveyServ.getInfoColabaradorPorPassword(refProd.idProducto,this.datos.datosColab.password).subscribe((respuesta:any) => {
     if (respuesta.success) {
       this.datosColaborador = respuesta.colaborador;
       this.modificacion = true;
       this.activarBoton('borrar',false); //false = activar boton :v
       if (this.datos.datosEmpresaProducto.statusEncuesta == 2) {
         console.log('Si se bloqueo por que ya esta finalizada su encuesta');
         this.activarBoton('modificar',true);
       }else{
         this.activarBoton('modificar',false); //false = activar boton :v
       }
     }else{
       this.datosColaborador = 'sinDatos';
     }
    });
  }

  editaColaborador(){
    let refProd = this.datos.datosEmpresaProducto.datosProducto;
    const dialogRef = this.dialog.open(NuevoColaboradorComponent, {
      width: '80%',
      height: '90%',
      disableClose: true,
      data: {
        // SurveyId: refProd.idSurvey,
        SurveyId: refProd.tokenMas50 != undefined ? refProd.tokenMas50 : [refProd.tokenMenos50 != undefined ? refProd.tokenMenos50 : refProd.idSurvey],
        idEmpresa: this.datos.datosEmpresaProducto.idEmpresa,
        idSurveyMas: refProd.idSurveyMas,
        idSurveyMenos: refProd.idSurveyMenos,
        idProducto: this.datos.datosEmpresaProducto.idProducto,
        tipoProducto: this.datos.datosEmpresaProducto.tipoProducto,
        datosColaborador: this.datosColaborador,
        modificacion: this.modificacion,
        statusEncuesta: this.datos.datosEmpresaProducto.statusEncuesta,
        tokenConfig:this.datos.datosEmpresaProducto.datosProducto.tokenConfig,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined){
        console.log("resultado:",result);
        if(result == true){
          this.statusSalidaModal = 2;
        }
      }
    });
  }

  resetSurve(){
    Swal.fire({
      title: this.translateSrv.instant('AVANCES.NEWCOLAB.RESET_COLAB_SURVE'),
      icon: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
      cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
    }).then((result) => {
      if (result.value) {
        this.surveyServ.resetSurvey(this.datosColaborador._id, this.datos.datosEmpresaProducto.datosProducto.tokenConfig).subscribe((respuesta:any) => {
          console.log("resetSurvey:",respuesta);
          if(respuesta.success){
            // this.statusSalidaModal = 2;
            this.mensajeSwal(this.translateSrv.instant('AVANCES.NEWCOLAB.ACTU_OK'),1,true);
          } else{
            // this.mensajeSwal(this.translateSrv.instant('COLABORADORES.MODALES.NOANSWERS'),1,true);
          }
        });
      }
    });
  }
  borrarColaborador(){
    Swal.fire({
      title: this.translateSrv.instant('AVANCES.NEWCOLAB.DELCOLAB'),
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
      cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
    }).then((result) => {
      if (result.value) {
        this.surveyServ.deleteColaborador(this.datosColaborador._id, this.datos.datosEmpresaProducto.datosProducto.idSurvey, this.datos.datosEmpresaProducto.datosProducto.tokenConfig).subscribe((respuesta:any) => {
          console.log("deleteColaborador:",respuesta);
          if(respuesta.success){
            this.statusSalidaModal = 2;
            this.mensajeSwal(this.translateSrv.instant('AVANCES.NEWCOLAB.DEL_OK'),1,true);
          } else{
            this.mensajeSwal(this.translateSrv.instant('COLABORADORES.MODALES.NOANSWERS'),1,true);
          }
        });
      }
    });
  }

  enviaInvitacion(){
    this.envio_paso2(1);
  }
  enviaRecordatorio(){
    this.envio_paso2(2);
  }
  envio_paso2(tipo:any){
    Swal.fire({
      title: this.translateSrv.instant("COLABORADORES.MODALES.ENVIOCORREO"),
      didOpen: () => {
        Swal.showLoading()
      }
    });
    let refProd = this.datos.datosEmpresaProducto;
    let refColab = this.datos.datosColab;
    let datos: any = {email: refColab.email != undefined ? refColab.email : refColab.name};
    switch (tipo) {
      case 1: datos.tipo = tipo; break;
      default:
      switch (refProd.tipoProducto) {
        case 40: case 41: case 42: case 43:
          if(refColab.id_status == 1){
            datos.tipo = 6;
          } else{
            datos.tipo = 7;
          }
        break;
        case 63:    //nom35 3.0
          datos.tipo = 7;
        break;
        default: datos.tipo = 2;
      }
    }
    let textoExito = tipo == 1 ? this.translateSrv.instant('AVANCES.ENCUESTA.SUCCESS1') : this.translateSrv.instant('AVANCES.ENCUESTA.SUCCESS2');
    let textoError = this.translateSrv.instant('AVANCES.ENCUESTA.ERROR1');
    this.surveyServ.send_email(datos, refProd.idEmpresa, refProd.idProducto).subscribe( (data: any) => {
      if(data.message == "Success"){
        this.mensajeSwal(textoExito, 1);
      }else{
        this.mensajeSwal(textoError, 3);
      }
    });
  }

  borraRespuestas(){
    let refProd = this.datos.datosEmpresaProducto;
    let refColab = this.datos.datosColab;
    let mensajeTexto1 = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ELIMINAR.MESSAGE1');
    let mensajeTexto2 = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ELIMINAR.MESSAGE2');
    let confirmarEmpresa = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ELIMINAR.VALIDAR');
    let salir = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ELIMINAR.SALIR');
    let errorNombreEmpresa = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ELIMINAR.ERRORNOMBREEMPRESA');

    let mensaje = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ELIMINAR.MENSAJE');
    let cancelar = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ELIMINAR.CANCELAR');
    let confirmar = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ELIMINAR.CONFIRMAR');
    let success = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ELIMINAR.SUCCES');
    let cerrar = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ELIMINAR.CERRAR');

    let mensajeTexto3 = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ELIMINAR.MESSAGE3');
    Swal.fire({
      title: `${mensajeTexto3}<font color="red">${refColab.name}</font>`,
      icon: 'info',
      input:'text',
      showCancelButton: true,
reverseButtons: true,


      cancelButtonText: salir,
      confirmButtonText: confirmarEmpresa
    }).then( (confirmacion) => {
      if (confirmacion.value == refColab.name) {
        Swal.fire({
          title: mensaje + refColab.name,
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,


          cancelButtonText: cancelar,
          confirmButtonText: confirmar
        }).then( (borrar) => {
          Swal.showLoading();
          console.log(borrar);
          if (borrar.value) {
            Swal.fire({
              title: this.translateSrv.instant("COLABORADORES.MODALES.BORRARESP"),
              didOpen: () => {
                Swal.showLoading()
              }
            });
            this.surveyServ.getInfoColabaradorPorPassword(refProd.idProducto, refColab.password).subscribe((respuesta:any) => {
             console.log("getInfoColab:",respuesta);
             if(respuesta.success){
               let datosBorrar: any = {
                 tokenSurvey: refProd.datosProducto.tokenConfig
               };
               this.surveyServ.delete_surveyAnswer(respuesta.colaborador._id, localStorage.getItem('instituto_id'), datosBorrar).subscribe( (data: any) => {
                 Swal.close();
                 let textoExito = this.translateSrv.instant('AVANCES.BOTONES-MODALES.SUCCESS-DELETE');
                 let textoError = this.translateSrv.instant('AVANCES.BOTONES-MODALES.ERROR-DELETE');
                 if(data.success){
                   this.mensajeSwal(textoExito, 1);
                   this.activarBoton('respuestas',true);
                 }else{
                   this.mensajeSwal(textoError, 3);
                 }

               });
             }
            });
          }
        });
      }
      else{
        if(!confirmacion.dismiss){
          Swal.fire({
            icon: 'error',
            title: errorNombreEmpresa,
            showConfirmButton: true,

            confirmButtonText: cerrar
          })
        }

      }
    });
  }

  mensajeSwal(mensaje:string, tipoMsg:number, cerrarModal?:boolean){
    let tipo: any;
    let rspSi = this.translateSrv.instant('MODALES.ACCIONES.aceptar');
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    }).then((result) => {
      if (result.value) {
        if(cerrarModal){
          this.salir();
        }
      }
    });
  }

  salir(){
    this.dialogRef.close(this.statusSalidaModal);
  }

}
